import { render, staticRenderFns } from "./CampaignOverviewFooter.vue?vue&type=template&id=57768e44&"
import script from "./CampaignOverviewFooter.vue?vue&type=script&lang=js&"
export * from "./CampaignOverviewFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports